import { useMemo } from 'react';
import { useTheme } from 'react-native-paper';

/**
 * Custom hook to create theme-aware styles with automatic memoization
 * @param {function} createStylesFunction - Function that takes theme and returns StyleSheet
 * @param {array} dependencies - Additional dependencies for memoization
 * @returns {object} Memoized styles
 */
const useThemedStyles = (createStylesFunction, dependencies = []) => {
  const theme = useTheme();

  const styles = useMemo(() => {
    return createStylesFunction(theme);
  }, [theme, createStylesFunction, ...dependencies]);

  return styles;
};

export default useThemedStyles;
